import * as React from "react";
import { DropdownMenu } from "radix-ui";
import { cn } from "./cn";

// Menu — the per-ROW action surface. A list row previously had exactly one interaction
// (click through to the detail page), so every action on an object required navigating to it
// first. That is fine for one object and miserable for twenty.

export interface MenuItemSpec {
  key: string;
  label: string;
  destructive?: boolean;
  disabled?: boolean;
  onSelect(): void;
}

export function Menu({ items, label = "Actions" }: { items: MenuItemSpec[]; label?: string }) {
  if (items.length === 0) return null;
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        aria-label={label}
        onClick={(e) => e.stopPropagation()} // the row itself navigates; the menu must not
        className={cn(
          "inline-grid min-h-8 min-w-8 place-items-center rounded-lg px-2 text-[16px] leading-none text-muted pointer-coarse:size-10",
          "hover:bg-surface2 hover:text-fg",
          " ",
        )}
      >
        ⋯
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end" sideOffset={4} collisionPadding={12}
          onClick={(e) => e.stopPropagation()}
          className={cn(
            "z-50 min-w-44 rounded-md border border-line bg-surface p-1 shadow-lg",
            " ",
          )}
        >
          {items.map((item) => (
            <DropdownMenu.Item
              key={item.key}
              disabled={item.disabled}
              onSelect={item.onSelect}
              className={cn(
                "cursor-pointer rounded px-2.5 py-2 text-sm outline-none pointer-coarse:py-3",
                "data-[disabled]:pointer-events-none data-[disabled]:opacity-40",
                item.destructive
                  ? "text-crit data-[highlighted]:bg-critsoft  "
                  : "text-fg data-[highlighted]:bg-surface2  ",
              )}
            >
              {item.label}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
